import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const DepartmentChart = ({ data }) => {
    const svgRef = useRef();

    useEffect(() => {
        if (!data || data.length === 0) return;

        // Dimensions
        const width = 400;
        const height = 250;
        const margin = { top: 20, right: 20, bottom: 40, left: 40 };

        // Clear previous SVG
        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove();

        // Scales
        const x = d3.scaleBand()
            .domain(data.map(d => d.department))
            .range([margin.left, width - margin.right])
            .padding(0.3);

        const y = d3.scaleLinear()
            .domain([0, d3.max(data, d => d.count) * 1.2]) // Add some headroom
            .range([height - margin.bottom, margin.top]);

        // Bars
        svg.selectAll(".bar")
            .data(data)
            .enter().append("rect")
            .attr("class", "bar")
            .attr("x", d => x(d.department))
            .attr("y", height - margin.bottom) // Start at bottom for animation
            .attr("width", x.bandwidth())
            .attr("height", 0) // Start with 0 height
            .attr("fill", "#6366f1")
            .attr("rx", 4) // Rounded corners
            .transition()
            .duration(800)
            .attr("y", d => y(d.count))
            .attr("height", d => height - margin.bottom - y(d.count))
            .delay((d, i) => i * 100);

        // Grid lines (optional)
        const yAxisGrid = d3.axisLeft(y).tickSize(-width + margin.right + margin.left).tickFormat('').ticks(5);
        svg.append('g')
            .attr('class', 'y-axis-grid')
            .attr('transform', `translate(${margin.left}, 0)`)
            .call(yAxisGrid)
            .style('color', '#e2e8f0')
            .style('stroke-dasharray', '3 3')
            .select('.domain').remove();


        // Axes
        svg.append("g")
            .attr("transform", `translate(0,${height - margin.bottom})`)
            .call(d3.axisBottom(x))
            .selectAll("text")
            .style("text-anchor", "middle")
            .style("font-size", "11px")
            .style("fill", "#64748b");

        // Remove X axis line for cleaner look
        svg.select(".domain").attr("stroke", "#e2e8f0");

        // Labels on top
        svg.selectAll(".label")
            .data(data)
            .enter().append("text")
            .text(d => d.count)
            .attr("x", d => x(d.department) + x.bandwidth() / 2)
            .attr("y", d => y(d.count) - 5)
            .attr("text-anchor", "middle")
            .style("font-size", "12px")
            .style("fill", "#6366f1")
            .style("font-weight", "bold")
            .style("opacity", 0)
            .transition()
            .delay((d, i) => i * 100 + 400)
            .style("opacity", 1);

        // Tooltip interaction
        const tooltip = d3.select("body").append("div")
            .attr("class", "d3-tooltip");

        svg.selectAll("rect")
            .on("mouseover", function (event, d) {
                d3.select(this).attr("fill", "#4f46e5");
                tooltip.style("visibility", "visible")
                    .text(`${d.department}: ${d.count} Employees`);
            })
            .on("mousemove", function (event) {
                tooltip.style("top", (event.pageY - 10) + "px")
                    .style("left", (event.pageX + 10) + "px");
            })
            .on("mouseout", function () {
                d3.select(this).attr("fill", "#6366f1");
                tooltip.style("visibility", "hidden");
            });

        return () => {
            tooltip.remove();
        }

    }, [data]);

    return <svg ref={svgRef} width="100%" height="250" viewBox="0 0 400 250"></svg>;
};

export default DepartmentChart;
